import React, {useRef} from 'react';
import {Editor} from '@tinymce/tinymce-react';

export default function RichTextEditor({html, setHTML, setPlainText}) {
  const editorRef = useRef(null);

  return (
    <Editor
      tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
      onInit={(evt, editor) => {
        editorRef.current = editor;
      }}
      value={html}
      onEditorChange={(value, editor) => {
        setHTML(value);
        setPlainText(editor.getContent({format: 'text'}));
      }}
      init={{
        height: 350,
        menubar: false,
        branding: false,
        // https://www.tiny.cloud/docs/plugins/opensource
        // https://www.tiny.cloud/docs/configure/content-appearance/#exampleusingcolor_cols
        plugins:
          'autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
        toolbar:
          'undo redo | formatselect | ' +
          'bold italic forecolor backcolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'removeformat | print help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      }}
    />
  );
}
